import React from 'react';
import { useI18n } from '@wordpress/react-i18n';
export function GaugeSelector({ railLabel, gauge, onGaugeChange }) {
    const { __ } = useI18n();
    return (React.createElement("div", { style: { marginBottom: '20px' } },
        React.createElement("label", { className: "ltg-control-label", style: { display: 'block', marginBottom: '10px', fontWeight: 600 } },
            railLabel,
            ":"),
        React.createElement("label", { style: { marginRight: '20px', cursor: 'pointer' } },
            React.createElement("input", { type: "radio", name: "gauge", value: "1520", checked: gauge === '1520', onChange: (e) => onGaugeChange(e.target.value), style: { marginRight: '5px' } }),
            __('1520 mm', 'ltg-widgets')),
        React.createElement("label", { style: { cursor: 'pointer' } },
            React.createElement("input", { type: "radio", name: "gauge", value: "1435", checked: gauge === '1435', onChange: (e) => onGaugeChange(e.target.value), style: { marginRight: '5px' } }),
            __('1435 mm', 'ltg-widgets'))));
}
